<div class="date-input-container" [style.--date-input-height]="height">
    <mat-form-field appearance="outline" [class.full-width]="fullWidth" [style.height]="height">
        <mat-label *ngIf="showLabel">{{ label | translate }}</mat-label>

        <input matInput [matDatepicker]="picker" [formControl]="dateControl" [attr.id]="id"
            [placeholder]="placeholder | translate" [min]="minDate" [max]="maxDate"
            (dateChange)="onDateSelected($event)" (click)="picker.open()" readonly>

        <div class="date-input-suffixes" matSuffix>
            <button *ngIf="clearable && dateControl.value && !dateControl.disabled" mat-icon-button type="button"
                (click)="clearDate($event)" class="clear-button" [title]="'common.clear' | translate"
                [attr.aria-label]="'common.clear' | translate" tabindex="0">
                <span class="clear-icon">✕</span>
            </button>
            <mat-datepicker-toggle [for]="picker" class="datepicker-toggle"></mat-datepicker-toggle>
        </div>

        <mat-datepicker #picker [startView]="startView" (monthSelected)="monthSelectedHandle($event, picker)"
            (yearSelected)="yearSelectedHandle($event, picker)" (closed)="markTouched()"></mat-datepicker>

        <mat-hint *ngIf="hint">{{ hint | translate }}</mat-hint>
        <mat-hint *ngIf="!hint && showFormatHint">
            {{ 'common.date_format_hint' | translate: { format: (formatLabel$ | async) } }}
        </mat-hint>

        <mat-error *ngIf="dateControl.hasError('required')">
            {{ 'validation.required' | translate }}
        </mat-error>

        <mat-error *ngIf="dateControl.hasError('minDate')">
            {{ 'validation.minDate' | translate: { date: minDate | localizedDate: 'date' } }}
        </mat-error>

        <mat-error *ngIf="dateControl.hasError('maxDate')">
            {{ 'validation.maxDate' | translate: { date: maxDate | localizedDate: 'date' } }}
        </mat-error>
    </mat-form-field>
</div>